export const radioCSS = {
    height: 28,
    width: 30,
    margin: 10,
};
